<div class="w-full">
  <div class="flex flex-col mb-2 border-b border-primary-600 header-background h-20 p-2 w-full">
    <div class="flex flex-row text-xs h-6"></div>
    <h1 class="mt-1">{{ { key: 'newProducts' } | i18n }}</h1>
  </div>

  @if (hits | async; as items) {
    @if (items.length > 0) {
      <div class="grid auto-cols-fr gap-y-8 md:grid-cols-2 xl:grid-cols-3">
        @for (item of items; track item.objectID; let i = $index) {
          <app-item-list-item [item]="item" [index]="i"></app-item-list-item>
        }
      </div>
    }
  }
</div>
